/*
 * @Author: cc
 * @Date: 2020-04-05 16:34:53
 * @LastEditTime: 2020-05-05 13:34:17
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\manuscriptShare\manuscriptShare.js
 * @Description: 
 */
'use strict';
angular.module('manuscriptShare', [])
    . controller('manuscriptShareCtrl', manuscriptShareCtrl);
manuscriptShareCtrl.inject = ['$scope', '$timeout', '$modalInstance', 'trsHttpService', 'trsspliceString', 'modalDialog', 'shareParams', '$filter'];

function manuscriptShareCtrl($scope, $timeout, $modalInstance, trsHttpService, trsspliceString, modalDialog, shareParams, $filter) {
    initStatus();
    initData();

    /**
     * [initStatus description] 初始化状态
     */
    function initStatus() {
        $scope.status = {
            shareTermOptions: [
                {name: '5小时', value: 5},
                {name: '一天', value: 24},
                {name: '两天', value: 48}
            ],
            shareParams: shareParams.data,
            copyLinkActive: false,
            shareLinkV: '',
            shareTermTimer: ''
        };
        $scope.status.shareTermOption = $scope.status.shareTermOptions[0];
        $scope.shareSelectedParams = {
            serviceid: 'mlf_docsharemanage',
            methodname: 'shareDoc',
            MetaDataId: $scope.status.shareParams.METADATAID,
            ShareDay: '5',
        };
        $scope.shareTermTimerParams = {
            serviceid: 'mlf_docsharemanage',
            methodname: 'updateShareTimes',
            ID: '',
            ShareDay: ''
        };
    }

    /**
     * [initData description] 初始化数据
     */
    function initData(){
        sendManuShareQuest();
    }

    /**
     * [sendManuShareQuest description] 发送分享请求
     */
    function sendManuShareQuest(){
        $scope.status.shareTermTimer = $filter('date')(new Date().getTime() + 5 * (1000 * 3600), 'yyyy-MM-dd HH:mm:ss').toString();
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.shareSelectedParams, 'post').then(function (data) {
            if (data.SUCCESS === 'true'){
                var params = data.DATA.url.split('?')[1];
                $scope.status.shareLinkV = window.location.origin + '/manuShareDetail/#/detail?' + params;
                $scope.shareTermTimerParams.ID = data.DATA.id;
            }
        });
    }

    /**
     * [shareTerm description] 分享期限
     */
    $scope.shareTerm = function(item){
        $scope.shareTermTimerParams.ShareDay = item.value;
        $scope.status.shareTermTimer = $filter('date')(new Date().getTime() + item.value * (1000 * 3600), 'yyyy-MM-dd HH:mm:ss').toString();
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.shareTermTimerParams, 'post').then(function (data) {
            if (!(data.SUCCESS === 'true')){
                modalDialog.alertType(data.MESSAGE, '', 'info', 'confirm', function() {});
            }
        });
    };

    /**
     * [copyShareLink description] 分享到剪切板
     */
    $scope.copyShareLink = function(event){
        event = event || window.event;
        event.stopPropagation();
        $scope.status.copyLinkActive = true;
        var input = document.getElementById('manus_share_cope_link');
        input.value = $scope.status.shareLinkV;
        input.select();
        document.execCommand('copy');
    };
    document.addEventListener('click', function(){
        $scope.status.copyLinkActive = false;
    });

    /**
     * [close description] 关闭
     */
    $scope.close = function() {
        $modalInstance.dismiss();
    };
}
